export const SITE_ENVIRONMENTS = {
  PRODUCTION: "production",
  STAGING: "staging",
  DEVELOPMENT: "development",
}

export const getSiteEnvironment = () =>
  process.env.GATSBY_ENVIRONMENT || SITE_ENVIRONMENTS.DEVELOPMENT

export const isProductionEnvironment = () =>
  getSiteEnvironment() === SITE_ENVIRONMENTS.PRODUCTION

export const shouldShowEnvironmentBanner = () =>
  process.env.GATSBY_SHOW_TEST_BANNER === "true" ||
  getSiteEnvironment() === SITE_ENVIRONMENTS.STAGING
